module.exports = __webpack_public_path__ + "img/square-gold-logo-large.bbac7316.png";